import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  CircularProgress,
  Alert,
  Typography,
  Box
} from '@mui/material';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

const DeleteChatSessionDialog = ({
  open,
  onClose,
  onConfirm,
  sessionName,
  isDeleting,
  error,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-chat-session-dialog-title"
      fullWidth
      maxWidth="xs"
    >
      <DialogTitle id="delete-chat-session-dialog-title" sx={{ display: 'flex', alignItems: 'center' }}>
        <DeleteForeverIcon sx={{ mr: 1, color: 'error.main' }} />
        Confirm Deletion
      </DialogTitle>
      <DialogContent>
        <DialogContentText component="div">
          Are you sure you want to permanently delete the session:
          <Typography component="strong" sx={{ fontWeight: 'bold', display: 'block', my: 1, color: 'text.primary' }}>
            {sessionName || 'this session'}
          </Typography>
          This action cannot be undone.
        </DialogContentText>
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions sx={{ p: '16px 24px' }}>
        <Button onClick={onClose} disabled={isDeleting}>
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={isDeleting}
          startIcon={isDeleting ? <CircularProgress size={20} color="inherit" /> : null}
        >
          {isDeleting ? 'Deleting...' : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteChatSessionDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  sessionName: PropTypes.string,
  isDeleting: PropTypes.bool,
  error: PropTypes.string,
};

export default DeleteChatSessionDialog;